import React from 'react';

function CatTravel() {
  return (
    <div className="container mt-5">
      <h1 className="text-center mb-4">喵行天下</h1>
      <div className="row">
        <div className="col-md-8 offset-md-2">
          <div className="card mb-4">
            <div className="card-body">
              <h5 className="card-title">带猫咪一起旅行的完美指南</h5>
              <p className="card-text">
                想带着您心爱的猫咪一起探索世界吗？我们的"喵行天下"为您提供全面的猫咪旅行指南，让您和猫咪的旅程更加愉快和安全。
              </p>
              
              <h6 className="mt-4">旅行前准备</h6>
              <ul className="list-group list-group-flush mb-3">
                <li className="list-group-item">确保猫咪健康状况良好，并获取兽医健康证明</li>
                <li className="list-group-item">准备合适的猫咪旅行箱和必要的旅行用品</li>
                <li className="list-group-item">了解目的地对宠物的入境要求和限制</li>
                <li className="list-group-item">预订接受宠物的住宿和交通工具</li>
                <li className="list-group-item">为猫咪准备熟悉的食物和玩具，减少环境变化带来的压力</li>
              </ul>
            </div>
          </div>
          
          <div className="card mb-4">
            <div className="card-body">
              <h5 className="card-title">猫咪友好的旅行目的地推荐</h5>
              <div className="row">
                <div className="col-md-6">
                  <div className="card mb-2">
                    <div className="card-body">
                      <h6 className="card-subtitle mb-2 text-muted">国内目的地</h6>
                      <ul className="list-unstyled">
                        <li>杭州西湖周边宠物友好酒店</li>
                        <li>成都宠物主题公园</li>
                        <li>三亚宠物海滩度假区</li>
                        <li>北京宠物友好咖啡馆街区</li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="card mb-2">
                    <div className="card-body">
                      <h6 className="card-subtitle mb-2 text-muted">国际目的地</h6>
                      <ul className="list-unstyled">
                        <li>日本东京猫咪咖啡馆</li>
                        <li>荷兰阿姆斯特丹运河游船</li>
                        <li>美国旧金山宠物友好海滩</li>
                        <li>意大利威尼斯宠物友好酒店</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">猫咪旅行故事分享</h5>
              <p className="card-text">
                分享您和猫咪的精彩旅行故事，或者浏览其他猫咪主人的旅行经历，获取灵感和实用建议。
              </p>
              <button className="btn btn-primary">查看旅行故事</button>
              <button className="btn btn-outline-primary ms-2">分享我的故事</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CatTravel;
